import { create } from 'zustand';

export const useUiStore = create((set) => ({
  mobileMenuOpen: false,
  openMobileMenu: () => set({ mobileMenuOpen: true }),
  closeMobileMenu: () => set({ mobileMenuOpen: false }),
  toggleMobileMenu: () => set((state) => ({ mobileMenuOpen: !state.mobileMenuOpen })),
  setMobileMenuOpen: (valueOrFn) =>
    set((state) => ({
      mobileMenuOpen:
        typeof valueOrFn === 'function' ? valueOrFn(state.mobileMenuOpen) : Boolean(valueOrFn),
    })),
}));
